<template>
  <el-container v-if="form">
    <div class="fixedFloatBar">
      <el-button
          class="cancel-button"
          plain="plain"
          @click="clickCancelCaregiver"
      >
        ยกเลิก
      </el-button>
      <el-button
          type="primary"
          @click="clickSubmitCaregiver"
          :disabled="isSaveButtonDisabled"
      >
        บันทึก
      </el-button>
    </div>
    <el-main class="container">
      <el-form class="form" ref="form" :model="form" :rules="rules" label-width="270px">
        <el-row>
          <div class="header-22-black head">ข้อมูลผู้ดูแล</div>
        </el-row>
        <el-form-item v-if="showProgress" style="margin-top: 30px;">
          <el-progress type="circle" :percentage="uploadPercent"></el-progress>
        </el-form-item>
        <el-form-item v-else style="margin-top: 30px;"><span slot="label"><span class="require-star">*</span><span class="label">รูปผู้ดูแล</span></span>
          <el-upload class="avatar-uploader" :http-request="uploadImage" :action="''" :on-success="uploadProfilePictureSuccess" :show-file-list="false"><img class="avatar" v-if="photo" :src="photo" /><i class="el-icon-plus avatar-uploader-icon" v-else></i></el-upload>
        </el-form-item>
        <el-form-item prop="nickName"><span slot="label"><span class="require-star">*</span><span class="label">ชื่อเล่น</span></span>
          <el-input v-model="form.nickName"></el-input>
        </el-form-item>
        <el-form-item prop="name"><span slot="label"><span class="require-star">*</span><span class="label">ชื่อจริง-นามสกุล</span></span>
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item><span class="label" slot="label">เพศ</span>
          <el-radio-group class="group-vertical radio" v-model="form.gender">
            <el-radio label="female">หญิง</el-radio>
            <el-radio label="male">ชาย</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="birthDate"><span slot="label"><span class="require-star">*</span><span class="label">วันเกิด</span></span>
          <div class="group-horizontal">
            <el-date-picker class="short" v-model="form.birthDate" type="date" placeholder="วัน / เดือน / ปี" value-format="yyyy-MM-dd" format="dd/MM/yyyy"></el-date-picker>
            <div class="trailing">อายุ {{age}} ปี</div>
          </div>
        </el-form-item>
        <el-form-item prop="weight"><span class="label" slot="label">น้ำหนัก</span>
          <div class="group-horizontal">
            <el-input class="short" v-model.number="form.weight"></el-input>
            <div class="trailing">กก.</div>
          </div>
        </el-form-item>
        <el-form-item prop="height"><span class="label" slot="label">ส่วนสูง</span>
          <div class="group-horizontal">
            <el-input class="short" v-model.number="form.height"></el-input>
            <div class="trailing">ซม.</div>
          </div>
        </el-form-item>
        <el-form-item prop="maritalStatus"><span class="label" slot="label">สถานภาพ</span>
          <el-radio-group class="group-vertical radio" v-model="form.maritalStatus">
            <el-radio label="single">ยังไม่แต่งงาน</el-radio>
            <el-radio label="married">แต่งงานแล้ว</el-radio>
            <el-radio label="divorced">หย่าร้าง</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="hasChildren"><span class="label" slot="label">บุตร</span>
          <el-radio-group class="group-vertical radio" v-model.number="form.hasChildren" @change="changeChildren">
            <el-radio :label="false">ไม่มีบุตร</el-radio>
            <el-radio :label="true">มี
              <el-input :disabled="!form.hasChildren" v-model="form.children" style="padding-left: 30px;" placeHolder="จำนวนบุตร"></el-input>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ศาสนา</span>
          <group-radio-with-extra-option :value.sync="form.religion" :list="[{&quot;key&quot;:&quot;buddhism&quot;,&quot;value&quot;:&quot;พุทธ&quot;},{&quot;key&quot;:&quot;christian&quot;,&quot;value&quot;:&quot;คริสต์&quot;},{&quot;key&quot;:&quot;islamic&quot;,&quot;value&quot;:&quot;อิสลาม&quot;}]"></group-radio-with-extra-option>
        </el-form-item>
        <el-form-item prop="citizenId"><span class="label" slot="label">เลขบัตรประชาชน</span>
          <el-input maxlength="13" v-model="form.citizenId"></el-input>
        </el-form-item>
        <el-form-item v-if="showProgress" style="margin-top: 30px;">
          <el-progress type="circle" :percentage="uploadPercent"></el-progress>
        </el-form-item>
        <el-form-item v-else style="margin-top: 30px;"><span class="label" slot="label">รูปบัตรประชาชน</span>
          <el-upload class="avatar-uploader" :http-request="uploadImage" :action="''" :on-success="uploadIdentifierCardSuccess" :show-file-list="false"><img class="avatar" v-if="citizenIdPhoto" :src="citizenIdPhoto" /><i class="el-icon-plus avatar-uploader-icon" v-else></i></el-upload>
        </el-form-item>
        <el-form-item prop="citizenId"><span class="label" slot="label">ไซส์เสื้อ</span>
          <el-input maxlength="13" v-model="form.shirtSize"></el-input>
        </el-form-item>

        <el-row style="margin-top: 100px; margin-bottom: 20px;">
          <div class="header-22-black head">การติดต่อ</div>
        </el-row>
        <el-form-item prop="phone"><span slot="label"><span class="require-star">*</span><span class="label">เบอร์โทร</span></span>
          <el-input maxlength="10" v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ไลน์ไอดี</span>
          <el-input v-model="form.line"></el-input>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ชื่อผู้ติดต่อฉุกเฉิน</span>
          <el-input v-model="form.emergencyContact.name"></el-input>
        </el-form-item>
        <el-form-item><span class="label" slot="label">สถานภาพ</span>
          <el-radio-group class="group-vertical radio" v-model="form.emergencyContact.relation">
            <el-radio label="offspring">บุตร</el-radio>
            <el-radio label="sibling">พี่/น้อง</el-radio>
            <el-radio label="spouse">คู่สมรส/แฟน</el-radio>
            <el-radio label="parents">พ่อ/แม่</el-radio>
            <el-radio label="relatives">ญาติ</el-radio>
            <el-radio label="outsider">ไม่ใช่คนในครอบครัว</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="emergencyContact.phone"><span class="label" slot="label">เบอร์โทรผู้ติดต่อฉุกเฉิน</span>
          <el-input maxlength="10" v-model="form.emergencyContact.phone"></el-input>
        </el-form-item>

        <el-row style="margin-top: 100px; margin-bottom: 20px;">
          <div class="header-22-black head">สถานที่่อยู่</div>
        </el-row>
        <el-form-item><span class="label" slot="label">สถานที่อยู่ปัจจุบัน</span>
          <el-input v-model="form.address.address"></el-input>
        </el-form-item>
        <el-form-item><span class="label" slot="label">จังหวัด</span>
          <el-select v-model="form.address.province" placeholder="เลือกจังหวัด" @change="changeProvince">
            <el-option v-for="province in provinces" :key="province.value" :label="province.label" :value="province.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><span class="label" slot="label">อำเภอ/เขต</span>
          <el-select v-model="form.address.district" placeholder="เลือกอำเภอ/เขต" @change="changeDistrict" :disabled="!form.address.province">
            <el-option v-for="district in districts" :key="district.value" :label="district.label" :value="district.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ตำบล/แขวง</span>
          <el-select v-model="form.address.subdistrict" placeholder="เลือกตำบล/แขวง" :disabled="!form.address.district">
            <el-option v-for="subdistrict in subdistricts" :key="subdistrict.value" :label="subdistrict.label" :value="subdistrict.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ภูมิลำเนา</span>
          <el-input v-model="form.hometown"></el-input>
        </el-form-item>

        <el-row style="margin-top: 100px; margin-bottom: 20px;">
          <div class="header-22-black head">การศึกษา</div>
        </el-row>
        <el-form-item><span class="label" slot="label">วุฒิการศึกษาสูงสุด</span>
          <el-radio-group class="group-vertical radio" v-model="form.education">
            <el-radio label="ตํ่ากว่า ป.6">ตํ่ากว่า ป.6</el-radio>
            <el-radio label="ม.3">ม.3</el-radio>
            <el-radio label="ม.6">ม.6</el-radio>
            <el-radio label="ปวช.">ปวช.</el-radio>
            <el-radio label="ปวส.">ปวส.</el-radio>
            <el-radio label="ปริญญาตรี">ปริญญาตรี</el-radio>
            <el-radio label="ปรญญาโท">ปริญญาโท</el-radio>
            <el-radio label="ปริญญาเอก">ปริญญาเอก</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ชื่อสถานศึกษาสูงสุด</span>
          <el-input v-model="form.educationPlace"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 45px"><span class="label" slot="label">ประกาศนียบัตรการดูแล</span>
          <div style="margin-top: 8px;">
            <radioSelectionInput label=" " prop="careCertificationPlace" :radioValue.sync="form.careCertification" :inputValue.sync="form.careCertificationPlace" placeHolder="ชื่อสถาบัน" styleVal="margin-top: -10px; margin-left: 200px;" :showInput="false">ไม่มี</radioSelectionInput>
            <radioSelectionInput label="NA" prop="careCertificationPlace" :radioValue.sync="form.careCertification" :inputValue.sync="form.careCertificationPlace" placeHolder="ชื่อสถาบัน" styleVal="margin-top: -10px; margin-left: 200px;">ประกาศนียบัตร พนักงานผู้ช่วยพยาบาล (NA)</radioSelectionInput>
            <radioSelectionInput label="PN" prop="careCertificationPlace" :radioValue.sync="form.careCertification" :inputValue.sync="form.careCertificationPlace" placeHolder="ชื่อสถาบัน"
                                 styleVal="margin-top: -10px; margin-left: 200px;">ประกาศนียบัตร ผู้ช่วยพยาบาล (PN)</radioSelectionInput>
          </div>
        </el-form-item>

        <el-row style="margin-top: 100px; margin-bottom: 20px;">
          <div class="header-22-black head">ช่องทางการรับเงิน</div>
        </el-row>
        <el-form-item><span class="label" slot="label">ธนาคาร</span>
          <group-radio-with-extra-option :value.sync="form.bankAccount.bank" :list="[{&quot;key&quot;:&quot;kbank&quot;,&quot;value&quot;:&quot;กสิกร KBANK&quot;},{&quot;key&quot;:&quot;scb&quot;,&quot;value&quot;:&quot;ไทยพาณิชย์ SCB&quot;},{&quot;key&quot;:&quot;bbl&quot;,&quot;value&quot;:&quot;กรุงเทพ BBL&quot;},{&quot;key&quot;:&quot;ktb&quot;,&quot;value&quot;:&quot;กรุงไทย KTB&quot;},{&quot;key&quot;:&quot;bay&quot;,&quot;value&quot;:&quot;กรุงศรี BAY&quot;},{&quot;key&quot;:&quot;tmb&quot;,&quot;value&quot;:&quot;ทหารไทย TMB&quot;},{&quot;key&quot;:&quot;gsb&quot;,&quot;value&quot;:&quot;ออมสิน GSB&quot;}]"></group-radio-with-extra-option>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ชื่อบัญชี</span>
          <el-input v-model="form.bankAccount.name"></el-input>
        </el-form-item>
        <el-form-item prop="bankAccount.number"><span class="label" slot="label">เลขที่บัญชี</span>
          <el-input maxlength="100" v-model="form.bankAccount.number"></el-input>
        </el-form-item>

        <el-row style="margin-top: 100px; margin-bottom: 20px;">
          <div class="header-22-black head">ภาพรวม</div>
        </el-row>
        <el-form-item prop="rating"><span class="label" slot="label">ภาพรวม</span>
          <el-input v-model="form.overviewNote"></el-input>
        </el-form-item>
        <el-form-item><span class="label" slot="label">บุคลิกภาพ</span>
          <el-input type="textarea" :rows="3" v-model="form.personalityNote"></el-input>
        </el-form-item>
        <el-form-item><span class="label" slot="label">ทักษะ</span>
          <el-input type="textarea" :rows="3" v-model="form.skillNote"></el-input>
        </el-form-item>
        <el-form-item prop="rating"><span class="label" slot="label">ไม่เหมาะกับเคส</span>
          <el-input v-model="form.notSuitableNote"></el-input>
        </el-form-item>

        <el-row style="margin-top: 100px; margin-bottom: 20px;">
          <div class="header-22-black head">ประสบการณ์การดูแล</div>
        </el-row>
        <el-form-item prop="type"><span slot="label"><span class="require-star">*</span><span class="label">ประเภทผู้ดูแล</span></span>
          <el-radio-group class="group-vertical radio" v-model="form.type">
            <el-radio label="CG">แคร์โปร ผู้ดูแลมืออาชีพ (CG)</el-radio>
            <radioClass v-if="form.class != 0 || form.classYear != 0  " label="CGN" prop="class" secondProp="classYear" :isCGN="true" :radioValue.sync="form.type" :inputValue.sync="form.class" :secondInputValue.sync="form.classYear"
                        placeHolder="รุ่น" secondPlaceHolder="ปี" styleVal="margin-left: 200px;">นักเรียนแคร์โปร ผู้ดูแลมืออาชีพ (CGN)</radioClass>
            <radioClass v-if="form.class === 0 &amp;&amp; form.classYear === 0 || !form.class &amp;&amp; !form.classYear" label="CGN" prop="class" secondProp="classYear" :isCGN="false" :radioValue.sync="form.type"
                        :inputValue.sync="form.class" :secondInputValue.sync="form.classYear" placeHolder="รุ่น" secondPlaceHolder="ปี" styleVal="margin-left: 200px;">นักเรียนแคร์โปร ผู้ดูแลมืออาชีพ (CGN)</radioClass>
            <el-radio label="NA">พนักงานผู้ช่วยพยาบาล (NA)</el-radio>
            <el-radio label="PN">ผู้ช่วยพยาบาล (PN)</el-radio>
            <el-radio label="RN">พยาบาล (RN)</el-radio>
            <el-radio label="DR">แพทย์ (DR)</el-radio>
            <el-radio label="PT">นักกายภาพบําบัด (PT)</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="yearOfExp"><span class="label" slot="label">ระยะการทํางาน</span>
          <div class="group-horizontal">
            <el-input class="short" v-model.number="form.yearOfExp"></el-input>
            <div class="trailing">ปี</div>
          </div>
        </el-form-item>
        <el-form-item prop="skillScores">
          <span slot="label"><span class="label">ทักษะการดูแล</span></span>
        </el-form-item>
        <el-form-item prop="skillScores" style="margin-top: -10px;">
          <span slot="label"><span class="sub-text">ทักษะทั่วไป</span></span>
        </el-form-item>
        <skill-score-bar
            v-for="skill in Value.skill.generalAll()"
            :key="skill"
            :label="skill"
            :skills.sync="form.skills"
        ></skill-score-bar>
        <el-form-item prop="skillScores" style="margin-top: 40px;">
          <span slot="label"><span class="sub-text">ทักษะอื่นๆ</span></span>
        </el-form-item>
        <skill-score-bar
            v-for="skill in Value.skill.othersAll()"
            :key="skill"
            :label="skill"
            :skills.sync="form.skills"
        ></skill-score-bar>

        <el-row style="margin-top: 100px; margin-bottom: 20px;">
          <div class="header-22-black head" style="margin-bottom: 21px;">ลิงค์ไฟล์</div>
        </el-row>
        <el-form-item><span class="label" slot="label">เอกสารอื่นๆ</span>
          <el-input type="textarea" :rows="3" v-model="form.note"></el-input>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<style lang="scss" scoped>
  $float-bar: 1000;
  .text {
    color: #A2A7B2;
    font-size: 18px;
    font-weight: 400;
    line-height: 2.2;
  }
  .sub-text {
    color: #A2A7B2;
    font-size: 18px;
    font-weight: 700;
    line-height: 2.2;
  }
  .el-container {
    display: flex;
    flex-direction: column
  }
  .el-main {
    padding: 30px 10px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .avatar-uploader:hover {
    border: 1px dashed #409EFF;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .avatar-uploader-icon {
    font-size: 24px;
    color: #909399;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .group-horizontal {
    display: flex;
    flex-direction: row;
  }
  .group-vertical {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    &.radio {
      margin-top: 12px;
      margin-left: 0px;
      font-size: 16px;
    }
   }
  .trailing {
    margin-left: 10px;
    font-size: 18px;
    color: #606266;
  }
  .short {
    max-width: 220px;
  }
  .el-button {
    margin: 10px;
    width: 120px;
  }
  .container {
    padding-top: 155px;
    padding-bottom: 100px;
    margin-bottom: 0 !important;
  }
  .fixedFloatBar {
    z-index: $float-bar;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background-color: white;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .form {
    width: 95%;
  }
  .el-radio+.el-radio {
    margin-left: 0px;
    margin-top: 15px;
  }
  .el-checkbox+.el-checkbox {
    margin-left: 0px;
  }
  i {
    margin-right: 5px;
  }
  .el-input {
    width: 60%;
    &.short {
      width: 50%
    }
  }
  .auto-complete-hospital {
    width: 300px;
  }
  .disease-container {
    margin-top: 10px;
    margin-left: 20px;
  }
  .extra-label-radio {
    width: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: -25px;
  }
  span.label {
    font-family: 'Sukhumvit-Bold';
    color: #303133;
    font-size: 18px;
    font-weight: 600;
  }
  .head {
    font-family: 'Sukhumvit-Bold';
    text-align: right;
    width: 260px;
    font-weight: 900;
  }

  .require-star {
    font-family: 'Sukhumvit';
    font-size: 18px;
    font-weight: normal;
    color: #C0C4CC;
    margin-right: 4px;
  }
</style>

<style lang="scss">
  .avatar-uploader .el-upload--text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  label.el-form-item__label {
    padding-right: 24px !important;
  }
</style>

<script>
import moment from 'moment'
import radioSelectionInput from '@/components/patient/form/RadioSelectionInput'
import GroupRadioWithExtraOption from '@/components/patient/form/GroupRadioWithExtraOption'
import CaregiverModel from '@/model/CaregiverModel'
import skillCheckbox from '@/components/patient/form/SkillCheckbox'
import SkillScoreBar from '@/components/patient/form/SkillScoreBar.vue'
import radioClass from '@/components/patient/form/RadioClass'
import { Convertable, Value } from '@/model/ModelUtil'
import { UploadImageHandler } from '@/components/shared/UploadImageHandler'

export default {
  name: 'CaregiverForm',
  mixins: [UploadImageHandler],
  components: {
    radioSelectionInput,
    skillCheckbox,
    SkillScoreBar,
    GroupRadioWithExtraOption,
    radioClass,
  },
  mounted () {
    this.getProvinces()
  },
  data () {
    const validateDate = (rule, value, callback) => {
      if (this.form.birthDate && (moment(this.form.birthDate).isValid)) callback()
      else callback(new Error('กรุณากรอกวันเกิดให้ถูกต้อง'))
    }
    const validateBank = (rule, value, callback) => {
      if (!['kbank', 'scb', 'bbl', 'ktb', 'bay', 'tmb', 'gsb'].includes(this.form.bankAccount.bank)) {
        callback()
      } else if (this.form.bankAccount.bank === 'gsb') {
        if (this.form.bankAccount.number.length === 12) callback()
        else callback(new Error('กรุณากรอกเลขที่บัญชี 12 หลัก'))
      } else if (this.form.bankAccount.bank !== '' || this.form.bankAccount.number.length !== 0) {
        if (this.form.bankAccount.number.length === 10) callback()
        else callback(new Error('กรุณากรอกเลขที่บัญชี 10 หลัก'))
      } else if (this.form.bankAccount.bank === '' && this.form.bankAccount.number.length === 0) {
        callback()
      }
    }
    return {
      form: new CaregiverModel(),
      provinces: [],
      districts: [],
      subdistricts: [],
      dialogImageUrl: '',
      dialogVisible: false,
      photo: '',
      citizenIdPhoto: '',
      rules: {
        birthDate: [
          { required: false, validator: validateDate, trigger: 'change' },
        ],
        nickName: [
          { required: false, trigger: 'blur', message: 'กรุณากรอกชื่อเล่น' },
        ],
        name: [
          { required: false, trigger: 'blur', message: 'กรุณากรอกชื่อจริง' },
        ],
        weight: [
          { required: false, type: 'number', min: 1, max: 200, message: 'กรุณากรอกตัวเลข 1-200', trigger: 'blur' },
        ],
        height: [
          { required: false, type: 'number', min: 20, max: 200, message: 'กรุณากรอกตัวเลข 20-200', trigger: 'blur' },
        ],
        citizenId: [
          { required: false, pattern: '^[0-9]{13}$', message: 'กรุณากรอกตัวเลข 13 หลัก', trigger: 'blur' },
        ],
        phone: [
          { required: false, pattern: '^[0-9]{10}$', message: 'กรุณากรอกตัวเลข 10 หลัก', trigger: 'blur' },
        ],
        emergencyContact: {
          phone: [
            { required: false, pattern: '^[0-9]{10}$', message: 'กรุณากรอกตัวเลข 10 หลัก', trigger: 'blur' },
          ],
        },
        yearOfExp: [
          { required: false, type: 'number', min: 0, max: 50, message: 'กรุณากรอกตัวเลข 1-50', trigger: 'blur' },
        ],
        type: [
          { required: false, trigger: 'blur' },
        ],
        rating: [
          { required: false, type: 'number', min: 0, max: 100, message: 'กรุณากรอกตัวเลข 0-100', trigger: 'blur' },
        ],
        bankAccount: {
          number: [
            { required: false, validator: validateBank, trigger: 'blur' },
          ],
        },
      },
    }
  },
  props: {
    caregiver: {
      type: Object,
      required: false,
    },
  },
  watch: {
    caregiver (val, oldVal) {
      this.form = val
      this.photo = val.photo
      this.citizenIdPhoto = val.citizenIdPhoto
      if (this.form.address.province && this.form.address.district && this.form.address.subdistrict) {
        this.getDistricts()
        this.getSubdistricts()
      }
    },
  },
  computed: {
    Value () {
      return Value
    },
    age () {
      return Convertable.date.from(this.form.birthDate).toAge()
    },
    isSaveButtonDisabled () {
      return !(this.photo &&
        this.form.nickName &&
        this.form.name &&
        this.form.birthDate &&
        this.form.type &&
        this.form.phone
      )
    },
  },
  methods: {
    async getProvinces () {
      try {
        let res = await this.$api.Resource.provinces()
        this.provinces = [...res.result.provinces]
          .map((province) => ({
            value: province,
            label: province,
          }))
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getDistricts () {
      try {
        let res = await this.$api.Resource.districts(this.form.address.province)
        this.districts = [...res.result.districts]
          .map((province) => ({
            value: province,
            label: province,
          }))
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getSubdistricts () {
      try {
        let res = await this.$api.Resource.subdistricts(this.form.address.province, this.form.address.district)
        this.subdistricts = [...res.result.subDistricts]
          .map((province) => ({
            value: province,
            label: province,
          }))
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    changeChildren () {
      this.form.children = null
    },
    uploadProfilePictureSuccess (res, file, fileList) {
      this.photo = file.response.downloadUrl
    },
    uploadIdentifierCardSuccess (res, file, fileList) {
      this.citizenIdPhoto = file.response.downloadUrl
    },
    clickSubmitCaregiver () {
      this.form.children = Number(this.form.children)
      this.form.age = this.age
      this.form.photo = this.photo
      this.form.citizenIdPhoto = this.citizenIdPhoto
      this.form.rating = this.form.rating === '' ? 0 : this.form.rating
      this.form.children = (this.form.hasChildren === '' || !this.form.hasChildren) ? 0 : this.form.children
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form)
        } else {
          this.$alert('ไม่สามารถบันทึก กรุณากรอกข้อมูลให้ถูกต้อง', '', {
            confirmButtonText: 'โอเค',
            showClose: false,
            type: 'error',
          })
        }
      })
    },
    clickCancelCaregiver () {
      this.$emit('cancel', this.form.id)
    },
    changeProvince () {
      this.getDistricts()
      this.form.address.district = ''
      this.form.address.subdistrict = ''
    },
    changeDistrict () {
      this.getSubdistricts()
      this.form.address.subdistrict = ''
    },
    async uploadImage (image) {
      if (!this.isImageAllowUpload(image.file)) return
      try {
        this.showProgress = true
        return await this.$api.Caregiver.uploadPhoto(image.file, this.onProgress)
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.uploadPercent = 0
        this.showProgress = false
      }
    },
  },
}
</script>
